export default "__VITE_ASSET__73a8c719__"